import {
  AuthorizationRequest,
  AuthorizationServiceConfiguration,
  FetchRequestor,
  RedirectRequestHandler,
} from '@openid/appauth';
import React, { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AuthContext from '../../contexts/AuthContext';
import oidcConfig from '../../oidcConfig';
import { setUserID } from '../../store/GoogleAnalytics/actions';

const AuthProvider = ({ children, onSetUserID }) => {
  const [tokenResponse, setTokenResponse] = React.useState(null);

  const signin = () => {
    const authorizationHandler = new RedirectRequestHandler();
    AuthorizationServiceConfiguration.fetchFromIssuer(oidcConfig.OPServer, new FetchRequestor())
      .then((response) => {
        const authRequest = new AuthorizationRequest({
          client_id: oidcConfig.clientId,
          redirect_uri: oidcConfig.redirectURL,
          scope: oidcConfig.scope,
          response_type: AuthorizationRequest.RESPONSE_TYPE_CODE,
          // Use a `undefined` value for the `state` parameter, to generate a random state for
          // CSRF protection (https://github.com/openid/AppAuth-JS/blob/a8c2962d7a24010ec1b4eb0e6eb3a9b0234f5733/src/authorization_request.ts#L62).
          state: undefined,
        });
        authorizationHandler.performAuthorizationRequest(response, authRequest);
      })
      .catch((error) => {
        console.error('Authorization error:', error);
      });
  };

  const signout = () => {
    window.location.replace(
      `${oidcConfig.endSessionEndpoint}?post_logout_redirect_uri=${oidcConfig.postLogoutRedirectUri}`,
    );
    onSetUserID(null);
  };

  const value = useMemo(
    () => ({ tokenResponse, setTokenResponse, signin, signout }),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should not include signout
    [tokenResponse],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onSetUserID: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onSetUserID: setUserID,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(AuthProvider);
